// Navbar.js
import {
  AlertDialog, AlertDialogBody, AlertDialogFooter,
  AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
  useDisclosure,
  Box,
  Divider,
  Flex,
  HStack,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  VStack,
  Avatar,
  Button
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiLogOut } from "react-icons/fi";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FiUser } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import { useRef } from 'react';

export default function Navbar() {

  const { user, authLoading, logout } = useAuth();
  const navigate = useNavigate();
  const WEB_APP_URL = process.env.REACT_APP_WEB_APP_URL;

  const handleLogout = async () => {
    await logout();
    navigate('/signin');
  };

  const { isOpen: isLogoutOpen, onOpen: onLogoutOpen, onClose: onLogoutClose } = useDisclosure();
  const cancelLogoutRef = useRef();

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      boxShadow="sm"
    >
      <Flex
        px="clamp(16px, 1.5vw, 32px)"
        py="clamp(10px, 0.8vw, 18px)"
        bg="white"
        borderBottom="1px solid #ECECEC"
        alignItems="center"
        justifyContent="space-between"
        height="clamp(60px, 4.5vh, 80px)"
      >
        {/* Logo */}
        <Link href={WEB_APP_URL} isExternal>
          <Image
            src="/logoHeader.svg"
            alt="Logo"
            h="clamp(24px, 2vw, 38px)"
          />
        </Link>

        {/* Right: User dropdown */}
        {authLoading ? null : user ? (
          <Menu
            placement="bottom-end"
            gutter={8}
          >
            <MenuButton
              py="6px"
              px="10px"
              borderRadius="12px"
              bg="white"
              border="1px solid #ECECEC"
              alignItems="center"
              justifyContent="space-between"
              height="clamp(45px, 4.5vh, 80px)"

              _hover={{ bg: "#F5F5F5 !important" }}
              _open={{
                bg: "white !important",
                _hover: { bg: "white !important" }  // Kill hover during open
              }}
              _focus={{
                bg: "white !important",
                boxShadow: "none !important"
              }}
            >
              <HStack>
                <Avatar
                  size="sm"
                  name={user.fullName}
                  src={user.avatarUrl || undefined}
                  bg="#CF008A"
                  color="white"
                />
                <Text
                  fontSize="clamp(14px, 1vw, 16px)"
                  fontWeight="semibold"
                  color="#242424"
                  noOfLines={1}
                  whiteSpace="nowrap"
                  flexShrink={0}
                >
                  {user.fullName}
                </Text>
                <ChevronDownIcon boxSize="clamp(16px, 1.2vw, 20px)" color="#6D6D6D" flexShrink={0} />
              </HStack>
            </MenuButton>
            <MenuList
              minW="260px"
              py={0}
              borderRadius="12px"
              boxShadow="lg"
              border="1px solid #ECECEC"
              zIndex={1100}
              bg="white"
            >
              <VStack py="16px" px="16px" align="center" spacing="8px">
                <Avatar
                  size="lg"
                  name={user.fullName}
                  src={user.avatarUrl || undefined}
                  bg="#CF008A"
                  color="white"
                />

                <Text fontSize="16px" fontWeight="semibold" color="#242424">
                  {user.fullName}
                </Text>
                <Text fontSize="14px" color="#6D6D6D">
                  {user.email}
                </Text>
              </VStack>
              <Divider borderColor="#ECECEC" />
              <MenuItem
                as={RouterLink}
                to="/profile"
                icon={
                  <FiUser size={20} color="black" />
                }
                iconSpacing="10px"
                py="12px"
                px="16px"
                fontSize="14px"
                fontWeight="medium"
                bg="transparent"
                _focus={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
                _hover={{ bg: "#F5F5F5" }}
                sx={{
                  "&[data-focus-visible]": { bg: "transparent" },
                  "[data-open] &": { bg: "transparent" }
                }}
              >
                My Profile
              </MenuItem>
              <Divider borderColor="#ECECEC" />
              <MenuItem
                icon={<Box as={FiLogOut}
                color="#CF008A" // color="#DE2424" 
                boxSize="18px" />}
                iconSpacing="10px"
                py="12px"
                px="16px"
                fontSize="14px"
                fontWeight="medium"
                // color="#DE2424"
                color="#CF008A"
                _hover={{ bg: '#FDF0F8' }}//"#FFF5F5" }}
                onClick={onLogoutOpen}
              >
                Log out
              </MenuItem>
            </MenuList>

          </Menu>
        ) : (<></>)
        }
      </Flex>
      <AlertDialog
        isOpen={isLogoutOpen}
        leastDestructiveRef={cancelLogoutRef}
        onClose={onLogoutClose}
        isCentered
      >
        <AlertDialogOverlay backdropFilter="blur(4px)" />
        <AlertDialogContent borderRadius="16px" p={2}>
          <AlertDialogHeader fontSize="18px" fontWeight="bold" color="#1A1A1A">
            Log out
          </AlertDialogHeader>
          <AlertDialogBody fontSize="14px" color="#6D6D6D">
            Are you sure you want to log out of your account?
          </AlertDialogBody>
          <AlertDialogFooter gap="8px">
            <Button
              ref={cancelLogoutRef}
              variant="ghost"
              color="#6D6D6D"
              borderRadius="10px"
              _hover={{ bg: '#F5F5F5' }}
              onClick={onLogoutClose}
            >
              Cancel
            </Button>
            <Button
              bg="#CF008A"
              color="white"
              borderRadius="10px"
              _hover={{ bg: '#D933A1' }}
              onClick={async () => { onLogoutClose(); await handleLogout(); }}
            >
              Yes, log out
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Box>
  );
}
